import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/users/:userId/employee-costs`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const employeeCosts = {
  getAll: apiPathFunc(pathBase),
};
